import React, { useCallback, useContext, useMemo } from 'react';
import { Box } from '@mui/material';
import { MessageResponse } from '@ujet/websdk-headless';
import { TextMessage } from '../TextMessage';
import { ChatbotWidgetContext } from 'components/ChatbotWidget/utils/ChatbotWidgetContext';
import styles from './InlineButtons.module.scss';
import classNames from 'classnames/bind';
import { Button } from 'components/baseComponents/Button';

const cx = classNames.bind(styles);

interface UjetButton {
  title: string;
  action: string;
}

interface InlineButtonsProps {
  message: MessageResponse;
  isFirstMessage: boolean;
  isLastMessage: boolean;
}

const EMPTY_BUTTON_PREFIX = '$playbook.input.options_list';

const CN = 'inline-buttons';

export const InlineButtons = ({
  message,
  isFirstMessage,
  isLastMessage
}: InlineButtonsProps): React.ReactElement => {
  const { client } = useContext(ChatbotWidgetContext);

  const buttons = useMemo(() => (message.buttons as UjetButton[]).filter(
    button => !button.title.startsWith(EMPTY_BUTTON_PREFIX)
  ), [ message.buttons ]);

  const handleButtonClick = useCallback((button: UjetButton) => {
    if (!client) return;

    switch (button.action) {
    case 'quick_reply':
      client.sendTextMessage(button.title);
      break;
    case 'escalation':
      client.escalateChat();
      break;
    default:
      break;
    }
  }, [ client ]);

  return (
    <Box className={ cx(CN) }>
      {message.title || isFirstMessage ? (
        <TextMessage message={ message } useTitle />
      ) : null}
      {isLastMessage && buttons.map((button, index) => (
        <Button key={ index } variant='primary' onClick={ (): void => handleButtonClick(button) }>
          {button.title}
        </Button>
      ))}
    </Box>
  );
};
